// src/types/workflow.ts
var WORKFLOW_STAGES = [
  "valoracion",
  // Assessment/intake - pending arrival
  "recepcion",
  // Vehicle checked in / arrived
  "diagnostico",
  // Diagnosis
  "presupuesto",
  // Quote stage (tracked only, quotes external)
  "aprobacion",
  // Awaiting customer approval
  "trabajo",
  // Work in progress
  "control_calidad",
  // Quality control
  "entrega",
  // Ready for delivery/pickup
  "completado",
  // Delivered/closed
  "cancelado",
  // Cancelled
  "no_show"
  // Customer didn't show
];
var STAGE_LABELS = {
  valoracion: "Valoraci\xF3n",
  recepcion: "Recepci\xF3n",
  diagnostico: "Diagn\xF3stico",
  presupuesto: "Presupuesto",
  aprobacion: "Aprobaci\xF3n",
  trabajo: "Trabajo",
  control_calidad: "Control de Calidad",
  entrega: "Entrega",
  completado: "Completado",
  cancelado: "Cancelado",
  no_show: "No Presentado"
};
var STAGE_DISPLAY_LABELS = {
  valoracion: "Pendiente Llegada",
  recepcion: "Recepcionado",
  diagnostico: "Diagn\xF3stico",
  presupuesto: "Presupuesto",
  aprobacion: "Aprobaci\xF3n",
  trabajo: "En Trabajo",
  control_calidad: "Control Calidad",
  entrega: "Pendiente Entrega",
  completado: "Completado",
  cancelado: "Cancelado",
  no_show: "No Show"
};
var STAGE_COLORS = {
  valoracion: "yellow",
  recepcion: "blue",
  diagnostico: "purple",
  presupuesto: "orange",
  aprobacion: "blue",
  trabajo: "purple",
  control_calidad: "indigo",
  entrega: "green",
  completado: "gray",
  cancelado: "red",
  no_show: "red"
};
var STAGE_COLOR_CLASSES = {
  valoracion: "bg-yellow-100 text-yellow-800 border-yellow-200",
  recepcion: "bg-blue-100 text-blue-800 border-blue-200",
  diagnostico: "bg-purple-100 text-purple-800 border-purple-200",
  presupuesto: "bg-orange-100 text-orange-800 border-orange-200",
  aprobacion: "bg-blue-100 text-blue-800 border-blue-200",
  trabajo: "bg-purple-100 text-purple-800 border-purple-200",
  control_calidad: "bg-indigo-100 text-indigo-800 border-indigo-200",
  entrega: "bg-green-100 text-green-800 border-green-200",
  completado: "bg-gray-100 text-gray-800 border-gray-200",
  cancelado: "bg-red-100 text-red-800 border-red-200",
  no_show: "bg-red-100 text-red-800 border-red-200"
};
var STAGE_DOT_CLASSES = {
  valoracion: "bg-yellow-500",
  recepcion: "bg-blue-500",
  diagnostico: "bg-purple-500",
  presupuesto: "bg-orange-500",
  aprobacion: "bg-blue-500",
  trabajo: "bg-purple-500",
  control_calidad: "bg-indigo-500",
  entrega: "bg-green-500",
  completado: "bg-gray-400",
  cancelado: "bg-red-500",
  no_show: "bg-red-500"
};
var STAGE_TRANSITIONS = {
  valoracion: ["recepcion", "cancelado", "no_show"],
  // Vehicle arrival or no-show
  recepcion: ["diagnostico", "cancelado"],
  // Vehicle checked in, move to diagnosis
  diagnostico: ["presupuesto", "cancelado"],
  // Diagnosis complete, create quote
  presupuesto: ["aprobacion", "cancelado"],
  aprobacion: ["trabajo", "cancelado"],
  trabajo: ["control_calidad", "cancelado"],
  control_calidad: ["entrega", "trabajo", "cancelado"],
  // Can go back to trabajo if QC fails
  entrega: ["completado", "cancelado"],
  completado: [],
  // Terminal state
  cancelado: [],
  // Terminal state
  no_show: []
  // Terminal state
};
function isValidTransition(from, to) {
  return STAGE_TRANSITIONS[from].includes(to);
}
function getNextStages(stage) {
  return STAGE_TRANSITIONS[stage] || [];
}
function getActiveStages() {
  return WORKFLOW_STAGES.filter(
    (stage) => stage !== "completado" && stage !== "cancelado" && stage !== "no_show"
  );
}
var BOOKING_TYPES = ["seguro", "particular"];
var BOOKING_TYPE_LABELS = {
  seguro: "Seguro",
  particular: "Particular"
};

// src/types/roles.ts
var ROLES = ["admin", "reception", "workshop", "customer"];
var STAFF_ROLES = ["admin", "reception", "workshop"];
var ROLE_LABELS = {
  admin: "Administrador",
  reception: "Recepci\xF3n",
  workshop: "Taller",
  customer: "Cliente"
};
var ROLE_PERMISSIONS = {
  admin: {
    canManageStaff: true,
    canManageBookings: true,
    canUpdateWorkshop: true,
    canViewReports: true,
    canManageRentals: true,
    canAccessPortal: false
  },
  reception: {
    canManageStaff: false,
    canManageBookings: true,
    canUpdateWorkshop: false,
    canViewReports: true,
    canManageRentals: true,
    canAccessPortal: false
  },
  workshop: {
    canManageStaff: false,
    canManageBookings: false,
    canUpdateWorkshop: true,
    canViewReports: false,
    canManageRentals: false,
    canAccessPortal: false
  },
  customer: {
    canManageStaff: false,
    canManageBookings: false,
    canUpdateWorkshop: false,
    canViewReports: false,
    canManageRentals: false,
    canAccessPortal: true
  }
};
function hasPermission(role, permission) {
  return ROLE_PERMISSIONS[role][permission];
}
function isStaffRole(role) {
  return STAFF_ROLES.includes(role);
}

// src/types/booking.ts
function getWorkflowStageLabel(stage) {
  return STAGE_LABELS[stage] || stage;
}
var ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "application/pdf"
];
var IMAGE_UPLOAD_CONSTRAINTS = {
  maxFileSize: 5 * 1024 * 1024,
  // 5MB
  acceptedTypes: ACCEPTED_IMAGE_TYPES
};
function isAcceptedImageType(mimeType) {
  return mimeType.startsWith("image/") || ACCEPTED_IMAGE_TYPES.includes(mimeType);
}

// src/types/repair.ts
var PHOTO_TYPES = ["before", "during", "after"];

// src/types/rental.ts
var RENTAL_STATUSES = ["available", "rented", "maintenance"];
var RENTAL_STATUS_LABELS = {
  available: "Disponible",
  rented: "Alquilado",
  maintenance: "En Mantenimiento"
};
var INQUIRY_STATUSES = ["pending", "responded", "booked", "declined"];
var INQUIRY_STATUS_LABELS = {
  pending: "Pendiente",
  responded: "Respondido",
  booked: "Reservado",
  declined: "Rechazado"
};

// src/types/auth.ts
import { z } from "zod";
var passwordSchema = z.string().min(8, "Password must be at least 8 characters").regex(/[A-Z]/, "Password must contain at least one uppercase letter").regex(/[a-z]/, "Password must contain at least one lowercase letter").regex(/[0-9]/, "Password must contain at least one number");
var passwordLoginSchema = z.object({
  email: z.string().email("Invalid email format"),
  password: z.string().min(1, "Password is required")
});
var forgotPasswordSchema = z.object({
  email: z.string().email("Invalid email format")
});
var resetPasswordSchema = z.object({
  token: z.string().min(1, "Token is required"),
  newPassword: passwordSchema
});
var changePasswordSchema = z.object({
  currentPassword: z.string().min(1, "Current password is required"),
  newPassword: passwordSchema
});

// src/types/staff.ts
import { z as z2 } from "zod";
var createStaffSchema = z2.object({
  email: z2.string().email("Invalid email format"),
  name: z2.string().min(2, "Name must be at least 2 characters").max(100),
  role: z2.enum(["admin", "reception", "workshop"]),
  password: passwordSchema,
  sendWelcomeEmail: z2.boolean().default(true)
});
var updateStaffSchema = z2.object({
  name: z2.string().min(2).max(100).optional(),
  role: z2.enum(["admin", "reception", "workshop"]).optional()
});
var adminResetPasswordSchema = z2.object({
  newPassword: passwordSchema,
  sendEmail: z2.boolean().default(true)
});

// src/types/marketing.ts
var TEMPLATE_PLACEHOLDERS = [
  "{{customer_name}}",
  "{{vehicle_make}}",
  "{{vehicle_model}}",
  "{{vehicle_registration}}",
  "{{booking_link}}"
];

// src/types/inquiry.ts
var LEAD_INQUIRY_STATUSES = ["new", "contacted", "converted", "dismissed"];
var SERVICE_INTERESTS = [
  "oil_change",
  "bodywork",
  "paint",
  "mechanical",
  "inspection",
  "other"
];

// src/types/booking-types.ts
var BOOKING_STATES = [
  "DRAFT",
  // Created but not sent to customer
  "PENDING_CONFIRMATION",
  // Awaiting customer confirmation
  "CONFIRMED",
  // Customer confirmed
  "CANCELLED",
  // Cancelled by customer or staff
  "RESCHEDULE_REQUESTED",
  // Customer requested reschedule
  "NO_SHOW"
  // Customer didn't arrive
];
var BOOKING_STATUS_LABELS = {
  DRAFT: "Borrador",
  PENDING_CONFIRMATION: "Pendiente de Confirmaci\xF3n",
  CONFIRMED: "Confirmada",
  CANCELLED: "Cancelada",
  RESCHEDULE_REQUESTED: "Reprogramaci\xF3n Solicitada",
  NO_SHOW: "No Presentado"
};
var WORKSHOP_BOOKING_SOURCES = ["customer", "staff"];
var BOOKING_STATUS_TRANSITIONS = {
  DRAFT: ["PENDING_CONFIRMATION", "CONFIRMED"],
  PENDING_CONFIRMATION: ["CONFIRMED", "CANCELLED"],
  CONFIRMED: ["CANCELLED", "RESCHEDULE_REQUESTED", "NO_SHOW"],
  CANCELLED: [],
  // Terminal
  RESCHEDULE_REQUESTED: ["CONFIRMED"],
  // Links to new booking via supersededById
  NO_SHOW: []
  // Terminal
};
function canTransitionBooking(from, to) {
  return BOOKING_STATUS_TRANSITIONS[from].includes(to);
}
var CASE_TYPE_LABELS = {
  private: "Particular",
  insurance: "Seguro",
  warranty: "Garant\xEDa"
};
var WARRANTY_TYPES = ["manufacturer", "extended", "dealer"];
var WARRANTY_TYPE_LABELS = {
  manufacturer: "Fabricante",
  extended: "Extensi\xF3n",
  dealer: "Concesionario"
};
var INTAKE_FIELD_TYPES = [
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "date",
  "select",
  "checkbox",
  "file"
];

// src/types/services.ts
var BAY_TYPES = ["mechanical", "bodywork", "diagnostics"];
var BAY_TYPE_LABELS = {
  mechanical: "Mec\xE1nica",
  bodywork: "Carrocer\xEDa",
  diagnostics: "Diagn\xF3stico"
};
var PRICE_DISPLAY_MODES = ["fixed", "from", "after_inspection"];
var PRICE_DISPLAY_MODE_LABELS = {
  fixed: "Precio Fijo",
  from: "Desde",
  after_inspection: "Tras Valoraci\xF3n"
};

// src/types/booking-status.ts
var BOOKING_STATUSES = [
  // Booking lifecycle statuses
  "UNVERIFIED",
  // Public booking, email not yet verified
  "PENDING_CONFIRMATION",
  // Awaiting customer/staff confirmation
  "CONFIRMED",
  // Confirmed appointment
  "AWAITING_DROPOFF",
  // Waiting for vehicle dropoff
  "DROPOFF_COMPLETE",
  // Vehicle received (job created)
  "READY_FOR_PICKUP",
  // Vehicle ready to be collected
  "VISIT_CLOSED",
  // Visit closed after pickup
  "CANCELLED",
  // Cancelled (any reason)
  "NO_SHOW",
  // Customer didn't show up
  "UNDEFINED"
  // Fallback status for removed workflow states
];
var STATUS_LABELS = {
  UNVERIFIED: "Sin Verificar",
  PENDING_CONFIRMATION: "Pendiente Confirmaci\xF3n",
  CONFIRMED: "Confirmado",
  AWAITING_DROPOFF: "Pendiente Entrega",
  DROPOFF_COMPLETE: "Entrega Completa",
  READY_FOR_PICKUP: "Listo para Recoger",
  VISIT_CLOSED: "Visita Cerrada",
  CANCELLED: "Cancelado",
  NO_SHOW: "No Presentado",
  UNDEFINED: "Sin definir"
};
var PUBLIC_STATUS_LABELS = {
  UNVERIFIED: "Pendiente Verificaci\xF3n",
  PENDING_CONFIRMATION: "Pendiente Confirmaci\xF3n",
  CONFIRMED: "Confirmado",
  AWAITING_DROPOFF: "Pendiente Entrega",
  DROPOFF_COMPLETE: "Recibido",
  READY_FOR_PICKUP: "Listo para Recoger",
  VISIT_CLOSED: "Visita Cerrada",
  CANCELLED: "Cancelado",
  NO_SHOW: "Cancelado",
  UNDEFINED: "Sin definir"
};
var STATUS_COLORS = {
  UNVERIFIED: { bg: "bg-rose-50", text: "text-rose-700", border: "border-rose-200" },
  PENDING_CONFIRMATION: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200" },
  CONFIRMED: { bg: "bg-green-50", text: "text-green-700", border: "border-green-200" },
  AWAITING_DROPOFF: { bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  DROPOFF_COMPLETE: { bg: "bg-cyan-50", text: "text-cyan-700", border: "border-cyan-200" },
  READY_FOR_PICKUP: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" },
  VISIT_CLOSED: { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200" },
  CANCELLED: { bg: "bg-red-50", text: "text-red-600", border: "border-red-200" },
  NO_SHOW: { bg: "bg-gray-200", text: "text-gray-600", border: "border-gray-300" },
  UNDEFINED: { bg: "bg-gray-50", text: "text-gray-700", border: "border-gray-200" }
};
var STATUS_ICONS = {
  UNVERIFIED: "mail-warning",
  PENDING_CONFIRMATION: "mail-question",
  CONFIRMED: "calendar-check",
  AWAITING_DROPOFF: "car-front",
  DROPOFF_COMPLETE: "log-in",
  READY_FOR_PICKUP: "car",
  VISIT_CLOSED: "check-circle-2",
  CANCELLED: "x-circle",
  NO_SHOW: "user-x",
  UNDEFINED: "circle-alert"
};
function getStatusClasses(status) {
  const colors = STATUS_COLORS[status];
  if (!colors) return "bg-gray-50 text-gray-600 border-gray-200";
  return `${colors.bg} ${colors.text} ${colors.border}`;
}
var UNIFIED_CASE_TYPES = ["private", "insurance", "warranty"];
var UNIFIED_CASE_TYPE_LABELS = {
  private: "Particular",
  insurance: "Seguro",
  warranty: "Garant\xEDa"
};
var STATUS_TRANSITIONS = {
  UNVERIFIED: ["PENDING_CONFIRMATION", "CANCELLED"],
  PENDING_CONFIRMATION: ["CONFIRMED", "CANCELLED"],
  CONFIRMED: ["AWAITING_DROPOFF", "CANCELLED"],
  AWAITING_DROPOFF: ["DROPOFF_COMPLETE", "CANCELLED"],
  DROPOFF_COMPLETE: ["READY_FOR_PICKUP"],
  READY_FOR_PICKUP: ["VISIT_CLOSED"],
  VISIT_CLOSED: [],
  CANCELLED: [],
  NO_SHOW: [],
  UNDEFINED: []
};
function isStatusRequired(status, caseType, serviceConfig) {
  if (!serviceConfig?.requiredStatuses) {
    return false;
  }
  return serviceConfig.requiredStatuses.some(
    (req) => req.status === status && (!req.bookingTypes || req.bookingTypes.length === 0 || req.bookingTypes.includes(caseType))
  );
}
function isStatusSkipped(status, caseType, serviceConfig) {
  if (!serviceConfig?.skipStatuses?.includes(status)) {
    return false;
  }
  if (isStatusRequired(status, caseType, serviceConfig)) {
    return false;
  }
  return true;
}
function canTransitionStatus(from, to, caseType, serviceConfig) {
  const allowed = STATUS_TRANSITIONS[from];
  if (!allowed.includes(to)) {
    return false;
  }
  if (isStatusSkipped(to, caseType, serviceConfig)) {
    return false;
  }
  return true;
}
function getValidNextStatuses(from, caseType, serviceConfig) {
  const allAllowed = STATUS_TRANSITIONS[from];
  let filtered = allAllowed.filter((s) => !isStatusSkipped(s, caseType, serviceConfig));
  return filtered;
}
function isTerminalStatus(status) {
  return STATUS_TRANSITIONS[status].length === 0;
}
function isPreArrivalStatus(status) {
  return ["UNVERIFIED", "PENDING_CONFIRMATION", "CONFIRMED", "AWAITING_DROPOFF"].includes(status);
}
function isUnverifiedStatus(status) {
  return status === "UNVERIFIED";
}
function isWorkshopStatus(status) {
  return ["DROPOFF_COMPLETE", "READY_FOR_PICKUP", "VISIT_CLOSED"].includes(status);
}
var JOB_BOARD_STATUSES = [
  "DROPOFF_COMPLETE",
  "READY_FOR_PICKUP"
];
var NOTIFICATION_TRIGGER_STATUSES = [
  "PENDING_CONFIRMATION",
  "CONFIRMED",
  "AWAITING_DROPOFF",
  "DROPOFF_COMPLETE",
  "READY_FOR_PICKUP",
  "VISIT_CLOSED",
  "CANCELLED"
];
var STATUS_EMAIL_TEMPLATES = {
  PENDING_CONFIRMATION: "booking-confirmation-request",
  CONFIRMED: "booking-confirmed",
  AWAITING_DROPOFF: "status-update",
  DROPOFF_COMPLETE: "status-update",
  READY_FOR_PICKUP: "status-update",
  VISIT_CLOSED: "status-update",
  CANCELLED: "booking-cancelled"
};
function mapWorkflowStageToStatus(stage, bookingStatus) {
  if (stage === "valoracion") {
    if (bookingStatus === "PENDING_CONFIRMATION") return "PENDING_CONFIRMATION";
    if (bookingStatus === "CANCELLED") return "CANCELLED";
    if (bookingStatus === "NO_SHOW") return "NO_SHOW";
    return "CONFIRMED";
  }
  const stageMap = {
    recepcion: "DROPOFF_COMPLETE",
    diagnostico: "DROPOFF_COMPLETE",
    presupuesto: "DROPOFF_COMPLETE",
    aprobacion: "DROPOFF_COMPLETE",
    trabajo: "DROPOFF_COMPLETE",
    control_calidad: "DROPOFF_COMPLETE",
    entrega: "READY_FOR_PICKUP",
    completado: "VISIT_CLOSED",
    cancelado: "CANCELLED",
    no_show: "NO_SHOW"
  };
  return stageMap[stage] || "CONFIRMED";
}
function mapJobStatusToBookingStatus(jobStatus) {
  const statusMap = {
    WAITING_FOR_ARRIVAL: "AWAITING_DROPOFF",
    CHECKED_IN: "DROPOFF_COMPLETE",
    VALORATION: "DROPOFF_COMPLETE",
    PERITATION: "DROPOFF_COMPLETE",
    AWAITING_APPROVAL: "DROPOFF_COMPLETE",
    IN_PROGRESS: "DROPOFF_COMPLETE",
    WAITING_PARTS: "DROPOFF_COMPLETE",
    FINALISING: "DROPOFF_COMPLETE",
    READY_TO_PICKUP: "READY_FOR_PICKUP",
    COMPLETED: "VISIT_CLOSED",
    ARCHIVED: "DROPOFF_COMPLETE",
    CANCELLED_BEFORE_DROP_OFF: "CANCELLED",
    CANCELLED_AFTER_DROP_OFF: "CANCELLED",
    UNDEFINED: "UNDEFINED"
  };
  return statusMap[jobStatus] || "CONFIRMED";
}

// src/types/workflow-config.ts
var WORKFLOW_BOOKING_TYPES = ["private", "insurance", "warranty"];
var WORKFLOW_TYPES = ["booking", "job"];
var STATUS_TYPES = ["start", "regular", "terminal"];
var EDGE_STYLES = ["default", "dashed", "conditional"];
var DIALOG_TYPES = [
  "none",
  "confirm",
  "notes",
  "cancel",
  "complete",
  "bay_select",
  "quote",
  "custom"
];
var CONDITION_TYPES = [
  "field_required",
  "field_value",
  "record_exists",
  "count_minimum",
  "time_in_status",
  "approval_required",
  "custom_expression"
];
var ACTION_TYPES = [
  "send_notification",
  "create_record",
  "update_field",
  "assign_resource",
  "trigger_webhook",
  "schedule_reminder"
];
var TIME_LIMIT_ACTIONS = ["warn", "escalate", "auto_transition"];
var CHANGE_TYPES = [
  "workflow_created",
  "status_added",
  "status_updated",
  "status_removed",
  "transition_added",
  "transition_updated",
  "transition_removed",
  "layout_updated"
];

// src/types/workflow-checklist.ts
var WORKFLOW_CHECKLIST_ITEM_TYPES = [
  "photo",
  "signature",
  "file",
  "text",
  "textarea",
  "number",
  "boolean",
  "select",
  "multiselect",
  "date",
  "datetime"
];
var WORKFLOW_RULE_TYPES = ["precondition", "postaction", "checklist"];
var WORKFLOW_ATTACHMENT_CATEGORIES = ["photo", "signature", "file"];

// src/types/status-checklist.ts
var STATUS_CHECKLIST_ITEM_TYPES = [
  "boolean",
  "number",
  "text",
  "photo",
  "signature",
  "select",
  "file",
  "textarea",
  "multiselect",
  "date",
  "datetime"
];

// src/schemas/audit.ts
var ACTOR_TYPES = ["staff", "customer", "system"];
var EVENT_CATEGORIES = ["success", "failure", "security", "neutral", "admin"];
var AUTH_EVENT_TYPES = {
  login_success_password: { displayName: "Password Login", category: "success" },
  login_success_passkey: { displayName: "Passkey Login", category: "success" },
  login_failed_password: { displayName: "Failed Password Login", category: "failure" },
  login_failed_passkey: { displayName: "Failed Passkey Login", category: "failure" },
  login_locked_out: { displayName: "Account Locked", category: "failure" },
  logout: { displayName: "Logout", category: "neutral" },
  password_changed: { displayName: "Password Changed", category: "security" },
  password_change_failed: { displayName: "Password Change Failed", category: "failure" },
  password_reset_requested: { displayName: "Password Reset Requested", category: "security" },
  password_reset_completed: { displayName: "Password Reset Completed", category: "security" },
  password_reset_failed: { displayName: "Password Reset Failed", category: "failure" },
  passkey_added: { displayName: "Passkey Added", category: "security" },
  passkey_removed: { displayName: "Passkey Removed", category: "security" },
  passkey_renamed: { displayName: "Passkey Renamed", category: "neutral" }
};
var STAFF_EVENT_TYPES = {
  staff_created: { displayName: "Staff Created", category: "admin" },
  staff_updated: { displayName: "Staff Updated", category: "admin" },
  staff_activated: { displayName: "Staff Activated", category: "admin" },
  staff_deactivated: { displayName: "Staff Deactivated", category: "admin" },
  staff_password_reset: { displayName: "Staff Password Reset", category: "admin" },
  staff_unlocked: { displayName: "Staff Account Unlocked", category: "admin" }
};
var ALL_EVENT_TYPES = { ...AUTH_EVENT_TYPES, ...STAFF_EVENT_TYPES };
var ENTITY_TYPES = ["auth", "staff", "booking", "customer", "vehicle"];
function getEventDisplayName(action) {
  const eventInfo = ALL_EVENT_TYPES[action];
  return eventInfo?.displayName || action;
}
function getEventCategory(action) {
  const eventInfo = ALL_EVENT_TYPES[action];
  return eventInfo?.category || "neutral";
}

export {
  WORKFLOW_STAGES,
  STAGE_LABELS,
  STAGE_DISPLAY_LABELS,
  STAGE_COLORS,
  STAGE_COLOR_CLASSES,
  STAGE_DOT_CLASSES,
  STAGE_TRANSITIONS,
  isValidTransition,
  getNextStages,
  getActiveStages,
  BOOKING_TYPES,
  BOOKING_TYPE_LABELS,
  ROLES,
  STAFF_ROLES,
  ROLE_LABELS,
  ROLE_PERMISSIONS,
  hasPermission,
  isStaffRole,
  getWorkflowStageLabel,
  ACCEPTED_IMAGE_TYPES,
  IMAGE_UPLOAD_CONSTRAINTS,
  isAcceptedImageType,
  PHOTO_TYPES,
  RENTAL_STATUSES,
  RENTAL_STATUS_LABELS,
  INQUIRY_STATUSES,
  INQUIRY_STATUS_LABELS,
  passwordSchema,
  passwordLoginSchema,
  forgotPasswordSchema,
  resetPasswordSchema,
  changePasswordSchema,
  createStaffSchema,
  updateStaffSchema,
  adminResetPasswordSchema,
  TEMPLATE_PLACEHOLDERS,
  LEAD_INQUIRY_STATUSES,
  SERVICE_INTERESTS,
  BOOKING_STATES,
  BOOKING_STATUS_LABELS,
  WORKSHOP_BOOKING_SOURCES,
  BOOKING_STATUS_TRANSITIONS,
  canTransitionBooking,
  CASE_TYPE_LABELS,
  WARRANTY_TYPES,
  WARRANTY_TYPE_LABELS,
  INTAKE_FIELD_TYPES,
  BAY_TYPES,
  BAY_TYPE_LABELS,
  PRICE_DISPLAY_MODES,
  PRICE_DISPLAY_MODE_LABELS,
  BOOKING_STATUSES,
  STATUS_LABELS,
  PUBLIC_STATUS_LABELS,
  STATUS_COLORS,
  STATUS_ICONS,
  getStatusClasses,
  UNIFIED_CASE_TYPES,
  UNIFIED_CASE_TYPE_LABELS,
  STATUS_TRANSITIONS,
  canTransitionStatus,
  getValidNextStatuses,
  isTerminalStatus,
  isPreArrivalStatus,
  isUnverifiedStatus,
  isWorkshopStatus,
  JOB_BOARD_STATUSES,
  NOTIFICATION_TRIGGER_STATUSES,
  STATUS_EMAIL_TEMPLATES,
  mapWorkflowStageToStatus,
  mapJobStatusToBookingStatus,
  WORKFLOW_BOOKING_TYPES,
  WORKFLOW_TYPES,
  STATUS_TYPES,
  EDGE_STYLES,
  DIALOG_TYPES,
  CONDITION_TYPES,
  ACTION_TYPES,
  TIME_LIMIT_ACTIONS,
  CHANGE_TYPES,
  WORKFLOW_CHECKLIST_ITEM_TYPES,
  WORKFLOW_RULE_TYPES,
  WORKFLOW_ATTACHMENT_CATEGORIES,
  STATUS_CHECKLIST_ITEM_TYPES,
  ACTOR_TYPES,
  EVENT_CATEGORIES,
  AUTH_EVENT_TYPES,
  STAFF_EVENT_TYPES,
  ALL_EVENT_TYPES,
  ENTITY_TYPES,
  getEventDisplayName,
  getEventCategory
};
